import { Typography } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { FlexColumnContainer } from 'src/components/styles';

const EmptySearchTermBox = () => {
  return (
    <FlexColumnContainer
      justifyContent="center"
      alignItems="center"
      fontSize={50}
      gap={1}
      mt={10}
    >
      <SearchIcon
        fontSize="inherit"
        sx={{
          color: 'text.secondary',
          opacity: 0.7,
        }}
      />
      <Typography
        variant="h4"
        textAlign="center"
        fontWeight="fontWeightMedium"
        color="text.secondary"
      >
        Busca los productos que desees
      </Typography>
    </FlexColumnContainer>
  );
};

export default EmptySearchTermBox;
